import styled from 'styled-components';

const St = {};

St.Navigator = styled.div`
  display: flex;
  flex: none;
  height: 100%;
`;

St.NavigatorLabel = styled.div`
  writing-mode: vertical-rl;
  text-orientation: mixed;
  text-align: center;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
`;

St.NavigatorTrigger = styled.button`
  background: #c0c0c0;
  color: #fff;
  padding: 0;
  border: none;
  cursor: pointer;
  outline: none;
  padding-bottom: 80%;
  padding-top: 5px;
  display: inline-grid;
`;

St.NavigatorContent = styled.div`
  width: 250px;
  overflow: auto;
  background-color: #d4d4d4;
  .ant-input-search { margin-top: 10px; }
  .ant-tree {
    li { 
      padding: 0; 
      color: #2f2f2f;
      span.ant-tree-iconEle { display: none; }
      li:first-child { margin-top: 5px; }
   }
    & > li {
      &:first-child { padding-top: 2px; }
      &:last-child { padding-bottom: 6px; }
      & > span { display: none; }
      & > .ant-tree-child-tree { 
        padding-left: 0;
        .ant-tree-child-tree { 
          padding-left: 25px; 
         .ant-tree-switcher-noop { display: none; }
       }
        & > .ant-tree-treenode-switcher-open, & > .ant-tree-treenode-switcher-close {
          margin-top: 15px;
          margin-bottom: 5px;
          padding-right: 5px;
          .ant-tree-node-content-wrapper { 
            cursor: auto; 
            width: 100%;
          }
          &:first-child { margin-top: 8px; }
          & > span { background-color: #dfdfdf; }
          & > .ant-tree-switcher { padding-left: 10px; cursor: pointer; }
        }
      }
    }
    a { color: #717171; }
  }
`;

export default St;
